import { Directive } from '@angular/core';

@Directive({
  selector: '[xpoTileRibbonClickable]',
  host: {
    class: 'xpo-TileRibbon--clickable',
  },
})
export class XpoTileRibbonClickableDirective {}
